import React, { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

import { getContentFromPrismic } from '../../useCases/termsOfUse';
import {
  modalOpen,
  termsOfUseAccept,
} from '../../../layout/redux/layoutActions';
import {
  acceptTermsOfUse,
  getTermsOfUse,
} from './controllers/termsOfUse.controller';

import { ContentProps } from '../termsOfUse/types';
import TermsOfUse from './termsOfUse';

import './termsOfUseModal.scss';

function TermsOfUseModal() {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { user } = useSelector((state: any) => state.layoutState);
  const [shouldOpen, setShouldOpen] = useState(true);
  const [content, setContent] = useState<ContentProps | null>(null);
  const version = content?.version && content?.version[0].text;

  const CONTENT_ID = 'terms-of-use';

  const isModal = location.pathname !== '/terms-of-use';

  const getContent = async () => {
    try {
      const { response } = await getContentFromPrismic(CONTENT_ID);

      if (response) {
        const formattedResponse: ContentProps = {
          version: response[0]?.data?.version,
          title: response[0]?.data?.title[0]?.text,
          data: response[0]?.data?.content,
        };

        setContent(formattedResponse);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onAcceptTermsOfUse = () => {
    setShouldOpen(false);
    dispatch(termsOfUseAccept({ version: version || '' }));
    if (!isModal) {
      history.push('/map/dashboard');
    }
  };

  const onAcceptButtonClick = () => {
    if (!!version) {
      acceptTermsOfUse({ version }, onAcceptTermsOfUse);
    }
  };

  const onDeclineButtonClick = () => {
    dispatch(modalOpen('sair'));
  };

  useLayoutEffect(() => {
    const isTermsOfUseAccepted =
      user?.terms_of_use?.accept || getTermsOfUse()?.accept;
    setShouldOpen(!isTermsOfUseAccepted);
    if (isTermsOfUseAccepted) {
      history.push('/map/dashboard');
    }
  }, [user]);

  useLayoutEffect(() => {
    getContent();
  }, []);

  return shouldOpen ? (
    <TermsOfUse
      content={content}
      onAcceptButtonClick={onAcceptButtonClick}
      onDeclineButtonClick={onDeclineButtonClick}
      isModal={isModal}
    />
  ) : null;
}

export default TermsOfUseModal;
